<div class="btn-group" dropdown [(isOpen)]="displayMenu" *rlNoPrivileges="['RL_LEGANTO_GUEST']" class="menu-holder menu-list" rlStopPropagation tabindex="-1" id="menu-holder-{{ uniqueId }}" stop-event>
  <ng-container *ngIf="_actions.length > 0">
    <button
      dropdownToggle
      type="button"
      class="btn btn-clear btn-icon-only dropdown-toggle"
      [ngClass]="displayMenu ? 'menu-displayed' : ''"
      id="menu-btn-{{ uniqueId }}"
      value="{{ 'collection.openOptions' | translate }}"
      attr.aria-label="{{ 'collection.openOptions' | translate }}: {{ elementName }}"
      accessibleTooltip
      [tooltip]="'collection.openOptions' | translate"
      triggers="manual"
      placement="auto">
      <i class="fa fa-ellipsis-h"></i>
    </button>
    <ul *dropdownMenu id="menu-dropdown-{{ uniqueId }}" class="menu-list-items right-menu ignore-elements dropdown-menu" draggable="false" role="menu" [rlFocusMe]="true">
      <li
        [tooltip]="action.tooltip | translate"
        role="menuitem"
        *ngFor="let action of _actions; let i = index"
        [id]="action.code + '-' + uniqueId"
        (click)="clickAction(action)"
        (keyup.enter)="clickAction(action)"
        [rlStopPropagation]
        [ngClass]="action.classes"
        [rlAria]="(action.label ? action.label : 'menu.' + action.code) | translate"
        [attr.aria-haspopup]="action.popup"
        [attr.data-toggle]="action.dataToggle ? action.dataToggle : ''"
        [attr.data-target]="action.dataTarget ? action.dataTarget : ''"
        [rlTabIndex]>
        <a class="dropdown-item">
          <span *ngIf="action.labelArr">
            <ng-container *ngFor="let label of action.labelArr">
              {{ (label | translate) + ' ' }}
            </ng-container>
          </span>
          <span *ngIf="!action.labelArr">
            {{ (action.label ? action.label : 'menu.' + action.code) | translate }}
          </span>
        </a>
      </li>
    </ul>
  </ng-container>
</div>
